import {
  Container,
  OneRow,
  RowCenter,
  SplitRow,
  StyledSkeleton,
} from './ModelCardSkeleton.styled';
import { Skeleton } from '@mui/material';

interface IModelCardSkeletonProps {
  index: number;
  opacityCoefficient?: number;
}

const ModelCardSkeleton = ({
  index,
  opacityCoefficient = 0.2,
}: IModelCardSkeletonProps) => {
  return (
    <Container opacityIndex={index} opacityCoefficient={opacityCoefficient}>
      <StyledSkeleton
        width={'100%'}
        height={'200rem'}
        animation="wave"
        variant="rectangular"
      />
      <RowCenter>
        <OneRow>
          <Skeleton width={'100%'} animation="wave" />
        </OneRow>
        <SplitRow>
          <Skeleton width={'30%'} animation="wave" />
          <Skeleton width={'20%'} animation="wave" />
        </SplitRow>
        <OneRow>
          <Skeleton width={'100%'} animation="wave" />
        </OneRow>
      </RowCenter>
    </Container>
  );
};
export default ModelCardSkeleton;
